<div class="page-container">
  <div class="page-header">
    <button mat-icon-button routerLink="/automakers">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h2 class="page-title">Tabela de Preços - {{ automaker?.company.companyName }}</h2>
      <p class="page-subtitle">Consulte e gerencie os preços dos produtos</p>
    </div>
  </div>

  <!-- Filters -->
  <div class="filter-section">
    <div class="filter-header">
      <mat-icon>tune</mat-icon>
      Filtros de Pesquisa
    </div>
    <div class="filter-body">
      <form [formGroup]="filterForm">
        <div class="filter-grid cols-4">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Part #</mat-label>
          <input matInput type="text" formControlName="part" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Descrição</mat-label>
          <input matInput type="text" formControlName="description" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>CAI</mat-label>
          <input matInput type="text" formControlName="cai" />
        </mat-form-field>
        <app-select-form-field
          label="LB"
          [control]="productLine"
          [options]="productLines"
          [display]="codeDisplayName"
          />
        </div>
      </form>
    </div>
    <div class="filter-footer">
      <div class="filter-footer-left">
        <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilter()">
          <mat-icon>search</mat-icon><span>Buscar Itens</span>
        </button>
        <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilter()">
          <mat-icon>refresh</mat-icon><span>Limpar Filtro</span>
        </button>
      </div>
      <div class="filter-footer-right">
        <button mat-flat-button color="primary" class="mic-btn-icon-left" [routerLink]="updatePriceTableRoute">
          <mat-icon>cloud_upload</mat-icon><span>Atualizar Tabela via Excel</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-section">
    <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micCellTemplate="let item; name: 'activeCell'">
        @if (item.status === 'A') {
          <mat-icon>check</mat-icon>
        }
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'removedCell'">
        @if (item.deleted) {
          <mat-icon>check</mat-icon>
        }
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'actionsCell'">
        <div class="flex flex-row gap-4">
          <!-- -->
        </div>
      </ng-container>
    </mic-table>
  </div>
</div>
